import { Stack, useMantineTheme } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import Trans from 'next-translate/Trans';

import { UserExperienceLevel } from '~/domains/contest/domains/services/enums/user-experience.enum';
import { Text } from '~/domains/design-system/Text';
import { Tooltip } from '~/domains/common/components/Tooltip/Tooltip';

import experiencedBadgeImage from './experiencedBadge.svg';
import highlyExperiencedBadgeImage from './highlyExperiencedBadge.svg';

function ExperienceTooltipLabel({
  level,
}: {
  level: UserExperienceLevel.HIGHLY_EXPERIENCED | UserExperienceLevel.EXPERIENCED;
}) {
  const { t } = useTranslation('contest');
  const theme = useMantineTheme();

  return (
    <Stack p={4} spacing={4}>
      <Text variant="title-medium">{t(`common.experienceLevel.${level}.title`)}</Text>

      <Text variant="body-medium" c={theme.colors.gray2[4]}>
        <Trans
          i18nKey={`contest:common.experienceLevel.${level}.description`}
          components={{
            li: <li />,
          }}
        />
      </Text>
    </Stack>
  );
}

function UserExperienceLevelBadge({ level }: { level: UserExperienceLevel }) {
  switch (level) {
    case UserExperienceLevel.EXPERIENCED:
      return (
        <Tooltip
          withArrow
          withinPortal
          label={<ExperienceTooltipLabel level={UserExperienceLevel.EXPERIENCED} />}
        >
          <div>
            <Image {...experiencedBadgeImage} alt="Experienced" />
          </div>
        </Tooltip>
      );
    case UserExperienceLevel.HIGHLY_EXPERIENCED:
      return (
        <Tooltip
          withArrow
          withinPortal
          label={<ExperienceTooltipLabel level={UserExperienceLevel.HIGHLY_EXPERIENCED} />}
        >
          <div>
            <Image {...highlyExperiencedBadgeImage} alt="Highly Experienced" />
          </div>
        </Tooltip>
      );
    default:
      return null;
  }
}

export default UserExperienceLevelBadge;
